const initState = {}

const projectReducer = (state = initState, action) => {
  switch (action.type) {
    case 'CREATE_PROJECT_SUCCESS':
      console.log('create project success');
      return state;
    case 'CREATE_PROJECT_ERROR':
      console.log('create project error');
      return state;
    case 'UPDATE_PROJECT_SUCCESS':
      console.log('update project success');
      return state;
    case 'UPDATE_PROJECT_ERROR':
      console.log('update project error', action.err.message);
      return state;
    case 'DELETE_PROJECT_SUCCESS':
      console.log('delete project success');
      return state;
    case 'DELETE_PROJECT_ERROR':
      console.log('delete project error');
      return state;
    default:
      return state;
  }
};

export default projectReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/projectReducer.js